const handleMainAction = (event, handleAction, data) => {
	if (event.code === "Space" || event.code === "Enter") {
		handleAction(data);
		event.preventDefault();
		event.stopPropagation();
		return false;
	}
};
const numericKeyDownHandler = (e, onEnterCallback) => {
	if (e.key === "Enter" && typeof onEnterCallback === "function") {
		onEnterCallback();
	}

	const allowedKeys = [
		"Backspace",
		"Tab",
		"ArrowLeft",
		"ArrowRight",
		"Delete"
	];

	const isCtrlCombo =
		(e.ctrlKey || e.metaKey) &&
		["a", "c", "v", "x"].includes(e.key.toLowerCase());

	if (allowedKeys.includes(e.key) || isCtrlCombo) {
		return;
	}

	if (!/^\d$/.test(e.key)) {
		e.preventDefault();
	}
};

const KeyboardUtils = {
	handleMainAction,
	numericKeyDownHandler
};

export default KeyboardUtils;
